import { sprintf } from 'sprintf-js';
import i18n from '../../lang/de/js/messages.json';

$(function () {
    'use-strict';

    let $formApiImage = $('#api-image');
    let $formImageUpdate = $('#image-update');
    let $formImageDelete = $('#image-delete');
    let $imageUploader = $('#image-uploader');
    let $dropzone = $('#basic-drop-zone');
    let $containerCardImgs = $('.container-img-cards');
    let $activeModal = null;
    let cardImgTmpl = $('#card-img-tmpl').text();

    let imageUploaderOptions = {
        url: $imageUploader.attr('action'),
        method: 'post',
        params: {},
        dropZone: '#' + $dropzone.attr('id'),
        maxFileNum: parseInt($imageUploader.data('max-file-num'), 10) || 2,
        maxFileSize: parseInt($imageUploader.data('max-file-size'), 10) || 8192 * 1024, // Bytes
        allowedFileName: /\.(png|jpe?g)$/,
        // @see documentation:
        // progress: '#upload-progress',
        // validator: () => {},
    };

    function uploadFail(e, file, i, xhr, status, error) {
        console.log(xhr, status, error);
        alert(sprintf(i18n.error.upload, file.name));
        removeCardImg();
    }

    function addCardImgs(files) {
        files.forEach((file, index) => {
            let $tmpl = $(cardImgTmpl);
            let $cardImg = $containerCardImgs.find('.col-card-img').first();

            if ($cardImg.length) {
                $cardImg.before($tmpl);
            } else {
                $cardImg = $containerCardImgs.find('.col-card-upload').first();
                $cardImg.after($tmpl);
            }
        });
    }

    function removeCardImg() {
        $containerCardImgs.find('.col-card-img.loading').first().remove();
    }

    function renderImage(e, file, index, data, status, xhr) {
        if  (data && data.success && data.file) {
            let file = data.file;
            let $cardImg = $containerCardImgs.find('.col-card-img.loading').last().find('.card-img');

            updateCardImgId($cardImg, file.id);
            updateCardImgTitle($cardImg, file.title);
            updateCardImgSrc($cardImg, file.thumb_url);
            updateCardImgBlank($cardImg, file.url);

            $cardImg.find('.preloader').remove();
            $cardImg.closest('.col-card-img').removeClass('loading');
        } else {
            if (xhr) {
                console.log('xhr', xhr.responseText);
                alert(sprintf(i18n.error.upload, file.name));
            }

            removeCardImg();
        }
    }

    function updateCardImgId($cardImg, id) {
        $cardImg.attr('data-id', id);
    }

    function updateCardImgTitle($cardImg, title) {
        $cardImg.attr('data-title', title);
        $cardImg.find('img').attr('alt', title);
        $cardImg.find('.title').text(title);
    }

    function updateCardImgSrc($cardImg, url) {
        $cardImg.attr('data-src', url);
        $cardImg.find('img').attr('src', url);
    }


    function updateCardImgBlank($cardImg, url) {
        $cardImg.find('.tool.blank-image').attr('href', url);
    }

    function generateImageUrl(url, imageId) {
        url = url.replace(/(image\/)\{id\}/, '$1' + imageId);

        return url;
    }

    function refreshModalForm(e, $form) {
        let $el = $(e.currentTarget);
        let $image = $el.closest('.card-img');
        let $img = $image.find('img');

        $form.find('img').attr('src', $img.attr('src'));
        $form.find('[name="id"]').val($image.attr('data-id'));
        $form.find('[name="title"]').val($image.attr('data-title'));
        $form.data('loading', false);

        $activeModal = $($el.data('target'));
        $activeModal.modal('show');
        $activeModal.on('hide.bs.modal', () => {
            if ($activeModal) {
                $activeModal.off('hide.bs.modal');
                $activeModal = null;
            }
        });
    };

    function updateImage() {
        let id = $formImageUpdate.find('[name="id"]').val();

        let url = generateImageUrl($formApiImage.attr('action') + $formImageUpdate.attr('action'), id);
        let method = $formImageUpdate.attr('method');
        let title = $formImageUpdate.find('[name="title"]').val();

        let data = {
            _method: method,
            title: title,
        };

        $formImageUpdate.data('loading', true);

        $.ajax({
            type: method,
            url: url,
            data: data,
            dataType: 'JSON',
            success: (response) => {
                $activeModal.modal('hide');
                let $cardImg = $('.card-img[data-id="' + id + '"]');
                updateCardImgTitle($cardImg, response.file.title);
            },
            error: (xhr, ajaxOptions, thrownError) => {
                $formImageUpdate.data('loading', false);
                console.log(xhr.responseText);
                alert(xhr.responseText);
            },
        });
    }

    function deleteImage() {
        let id = $formImageDelete.find('[name="id"]').val();

        let url = generateImageUrl($formApiImage.attr('action') + $formImageDelete.attr('action'), id);
        let method = $formImageDelete.attr('method');

        let data = {
            _method: method,
        };

        $formImageDelete.data('loading', true);

        $.ajax({
            type: method,
            url: url,
            data: data,
            dataType: 'JSON',
            success: (response) => {
                $activeModal.modal('hide');
                $('.card-img[data-id="' + id + '"]').closest('.col-card-img').remove();
            },
            error: (xhr, ajaxOptions, thrownError) => {
                $formImageDelete.data('loading', false);
                console.log(xhr.responseText);
                alert(xhr.responseText);
            },
        });
    }

    $imageUploader.find('input[type="file"]').simpleUpload(imageUploaderOptions)
        .on('upload:before', (e, files) => {
            // Before first upload.
            addCardImgs(files);
        }).on('upload:after', (e, files) => {
            // All uploads complete.
        }).on('upload:start', (e, file, i) => {
            // A single file upload has started.
        }).on('upload:progress', (e, file, i, loaded, total) => {
            // ('progress ' + i + ' ' + loaded + '/' + total);
        }).on('upload:end', (e, file, i) => {
            // The upload of a single file is complete (both: success or fail).
        }).on('upload:done', (e, file, i, data, status, xhr) => {
            // The upload of a single file has completed successfully.
            renderImage(e, file, i, data, status, xhr);
        }).on('upload:fail', (e, file, i, xhr, status, error) => {
            // The upload of a single file has failed.
            uploadFail(e, file, i, xhr, status, error);
        });

    // Add hover effect to dropzone.
    $dropzone.on('dragover', (e) => {
        $dropzone.addClass('hover');
    });

    // Remove hover effect from dropzone.
    $dropzone.on('dragleave mouseleave', (e) => {
        $dropzone.removeClass('hover');
    });

    $formImageUpdate.data('loading', false);
    $formImageDelete.data('loading', false);

    $formImageUpdate.on('submit', (e) => {
        e.preventDefault();

        if ($activeModal && !$formImageUpdate.data('loading')) {
            $formImageUpdate.data('loading', false);
            updateImage();
        }
    });

    $formImageDelete.on('submit', (e) => {
        e.preventDefault();

        if ($activeModal && !$formImageDelete.data('loading')) {
            $formImageDelete.data('loading', false);
            deleteImage();
        }
    });

    $(document).on('click', '.toolbar .tool', (e) => {
        if ($(e.currentTarget).attr('href') === '#') {
            e.preventDefault();
        }
    });

    $(document).on('click', '.edit-image', (e) => {
        refreshModalForm(e, $formImageUpdate);
    });

    $(document).on('click', '.delete-image', (e) => {
        refreshModalForm(e, $formImageDelete);
    });
});